// bookie-champagne-preview — Sham Sha'oma catalog card (bk21).
//
// Champagne bookie: pale gradient ring, a scalloped deckle band under
// the eyebrow, soft circular medallion with the brand monogram or
// photo. "TAKLIFNOMA" eyebrow / template-font names / small-caps
// caption — all colours from LayoutCtx so any champagne-family bookie
// renders consistently.
import { Photo, type LayoutCtx } from "./_shared";

export function BookieChampagnePreviewLayout({
  names,
  date,
  venue,
  accent,
  ink,
  bg,
  font,
  photo,
}: LayoutCtx) {
  return (
    <div
      style={{
        position: "absolute",
        inset: 0,
        background: `linear-gradient(135deg, ${accent}55 0%, ${bg} 50%, ${accent}55 100%)`,
        padding: "5%",
        display: "flex",
      }}
    >
      <div
        style={{
          flex: 1,
          background: bg,
          color: ink,
          position: "relative",
          padding: "8%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          boxShadow: `inset 0 0 0 1px ${accent}55, inset 0 0 0 6px ${bg}, inset 0 0 0 7px ${accent}33`,
        }}
      >
        {/* Deckle band under the eyebrow */}
        <div
          aria-hidden
          style={{
            position: "absolute",
            top: "6%",
            left: "16%",
            right: "16%",
            height: 4,
            backgroundImage: `radial-gradient(circle at 50% 0%, ${accent} 1.2px, transparent 1.5px)`,
            backgroundSize: "6px 4px",
            opacity: 0.55,
          }}
        />

        <div
          style={{
            fontFamily: "var(--font-ui)",
            fontSize: 7,
            fontWeight: 700,
            letterSpacing: "0.4em",
            color: accent,
            marginBottom: "5%",
          }}
        >
          TAKLIFNOMA
        </div>

        {/* Champagne medallion */}
        <div style={{ width: "60%", aspectRatio: "1 / 1", position: "relative", marginBottom: "5%" }}>
          <div
            style={{
              position: "absolute",
              inset: 0,
              borderRadius: "50%",
              background: `linear-gradient(135deg, ${accent} 0%, ${accent}88 50%, ${accent} 100%)`,
              padding: "4%",
            }}
          >
            <div
              style={{
                width: "100%",
                height: "100%",
                borderRadius: "50%",
                background: bg,
                padding: "5%",
                boxSizing: "border-box",
              }}
            >
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  borderRadius: "50%",
                  overflow: "hidden",
                  position: "relative",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Photo
                  src={photo}
                  style={{ position: "absolute", inset: 0, width: "100%", height: "100%" }}
                  fallback={
                    <>
                      <div
                        style={{
                          position: "absolute",
                          inset: 0,
                          background: `radial-gradient(circle at 50% 45%, ${accent}44, ${bg})`,
                        }}
                      />
                      <svg viewBox="0 0 60 60" style={{ position: "relative", width: "62%" }}>
                        <g fill="none" stroke={accent} strokeWidth="0.9" opacity="0.8">
                          <path d="M20 18 Q 30 8 40 18 Q 38 30 30 38 Q 22 30 20 18 Z" />
                          <circle cx="30" cy="44" r="1.6" fill={accent} />
                        </g>
                      </svg>
                    </>
                  }
                />
              </div>
            </div>
          </div>
        </div>

        <div style={{ fontFamily: font, fontSize: 30, lineHeight: 1.05, fontWeight: 500, color: ink }}>
          {names}
        </div>

        <div style={{ flex: 1 }} />

        <div
          style={{
            fontFamily: "var(--font-ui)",
            fontSize: 6.5,
            fontWeight: 700,
            letterSpacing: "0.32em",
            color: accent,
            marginTop: "4%",
          }}
        >
          TAKLIFNOMA · {date.toUpperCase()}
        </div>
        <div
          style={{
            fontFamily: "var(--font-ui)",
            fontSize: 6,
            fontWeight: 600,
            letterSpacing: "0.28em",
            color: `${ink}99`,
            marginTop: 6,
          }}
        >
          {venue.toUpperCase()}
        </div>
      </div>
    </div>
  );
}
